var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMargin05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 144,
    viewBox: "0 0 121 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M93.9688 15.5586V41.0786H119.489V28.3186C119.489 21.2686 113.779 15.5586 106.729 15.5586H93.9688Z",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M68.46 141.618H14.76C7.71001 141.618 2 135.908 2 128.858V116.098H27.52",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.5195 28.3086V116.099H68.4595V128.859C68.4595 135.909 74.1695 141.619 81.2195 141.619C88.2695 141.619 93.9795 135.909 93.9795 128.859V15.5586H40.2795C33.2295 15.5586 27.5195 21.2686 27.5195 28.3186V28.3086Z",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M70.6786 38.1373C70.6786 38.1373 67.0186 34.5273 61.4986 34.5273C55.9786 34.5273 53.0186 37.2873 53.0186 41.4873C53.0186 45.6873 57.2886 47.4273 61.8486 48.8273C66.4086 50.2273 70.0286 52.4573 70.0286 56.0873C70.0286 59.7173 66.5186 62.8773 61.4986 62.8773C56.4786 62.8773 50.8086 58.8173 50.8086 58.8173",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M61.5 28.5078V69.8078",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M41.8301 81.8887H80.4401",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M41.8301 93.959H80.4401",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M41.8301 106.039H80.4401",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M112.09 115.689C115.051 115.689 117.451 113.289 117.451 110.329C117.451 107.369 115.051 104.969 112.09 104.969C109.13 104.969 106.73 107.369 106.73 110.329C106.73 113.289 109.13 115.689 112.09 115.689Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M11.9596 74.6497C14.9198 74.6497 17.3196 72.2499 17.3196 69.2897C17.3196 66.3294 14.9198 63.9297 11.9596 63.9297C8.99935 63.9297 6.59961 66.3294 6.59961 69.2897C6.59961 72.2499 8.99935 74.6497 11.9596 74.6497Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M86.3206 68.4902C89.0606 68.4902 89.0606 64.2402 86.3206 64.2402C83.5806 64.2402 83.5806 68.4902 86.3206 68.4902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M103.92 90.5801C106.66 90.5801 106.66 86.3301 103.92 86.3301C101.18 86.3301 101.18 90.5801 103.92 90.5801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M103.92 4.25C106.66 4.25 106.66 0 103.92 0C101.18 0 101.18 4.25 103.92 4.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M46.2796 59.9609C49.0196 59.9609 49.0196 55.7109 46.2796 55.7109C43.5396 55.7109 43.5396 59.9609 46.2796 59.9609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M17.3089 38.2402C20.0489 38.2402 20.0489 33.9902 17.3089 33.9902C14.5689 33.9902 14.5689 38.2402 17.3089 38.2402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M20.3206 90.5801C23.0606 90.5801 23.0606 86.3301 20.3206 86.3301C17.5806 86.3301 17.5806 90.5801 20.3206 90.5801Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMargin05);
export default __webpack_public_path__ + "static/media/icon_margin_05.cb6258281c6c6502ed511f49a88a3fae.svg";
export { ForwardRef as ReactComponent };